import moment from 'moment-timezone';

const tzLondon = 'Europe/London';

export default function formatDate(dateStr, format) {
    return dateStr ? moment.tz(dateStr, tzLondon).format(format) : '';
}



// WEBPACK FOOTER //
// ./~/rp-react-common/src/utils/date.js